import { useContext } from 'react';
import { Icon } from '@mui/material';
import './Pagination.scss';
import { AccessibilityContext } from '../../store/accesibility-context';

function Pagination({
	currentPage,
	sizeNumber,
	totalNumber,
	changePage
}) {
	const accessibilityCtx = useContext(AccessibilityContext);
	const totalPages = Math.ceil(totalNumber / sizeNumber);
	const pages = Array(totalPages)
		.fill()
		.map((v, i) => ++i);
	const handlePageChange = (pageNumber) => {
		changePage(pageNumber);
	};
	return (
		<div className='pages-list'>
			{currentPage > 1 && (
				<Icon
					onClick={() => handlePageChange(currentPage - 1)}
				>
					chevron_left
				</Icon>
			)}
			{pages.map((item, index) => {
				return (
					<a
						key={index}
						onClick={() => handlePageChange(item)}
						className={`${accessibilityCtx.contrast ? 'page-item-contrast':'page-item'} ${
							currentPage === item ? 'active' : ''
						}`}
					>
						{item}
					</a>
				);
			})}
			{currentPage < totalPages && (
				<Icon
					onClick={() => handlePageChange(currentPage + 1)}
				>
					chevron_right
				</Icon>
			)}
		</div>
	);
}

export default Pagination;
